import { SBaseDisplay } from '@summit/core';

import { SpotWage } from '../shared/spot-wage';
import { SpotRun } from './spot-run';

export class SpotRunWage extends SpotWage implements SBaseDisplay {
  spotRunID: string;
  spotRun: SpotRun;

  constructor(jsonData?: Partial<SpotRunWage>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.spotRun) {
        this.spotRun = new SpotRun(jsonData.spotRun);
      }
    }
  }
}
